import axios from 'axios';

const cmsAxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_REST_API}/.rest/delivery`,
});

const baseAxiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_REST_API}`,
});

export { cmsAxiosInstance, baseAxiosInstance };
